import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from 'hooks';

function AuthRoute({ children }) {
	const location = useLocation();
	const auth = useAuth();

	if (auth && auth?.access_token) {
		return <Navigate to="/dashboard" state={{ from: location }} replace />;
	}
	return children;
}

AuthRoute.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default AuthRoute;
